/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = require("source-map");


//////////////////
// WEBPACK FOOTER
// (webpack)-core/lib/source-map.js
// module id = 4063
// module chunks = 0